import React from 'react';
import './Education.css';

const Education = () => {
  const education = [
    {
      institution: 'Coursera',
      year : "2025",
      description: "Completed three advanced Coursera specializations, building a rigorous foundation in machine learning theory, deep learning architectures, and the mathematics underpinning AI, with hands-on expertise in model development and optimization.",
      highlights: [
        'Mathematics for Machine Learning',
        'Machine learning specialization',
        'Deep learning specialization'
      ]
    },
    {
      institution: '10 Academy AI Mastery Training Program',
      year: '2024',
      description: 'Specialized training in ML pipelines and financial analytics, with hands-on experience in implementing AI solutions.',
      highlights: [
        'Machine Learning Pipeline Development',
        'Financial Data Analysis',
        'AI Model Deployment',
        'Real-world Project Implementation'
      ]
    },
    {
      institution: 'Unity University',
      year: '2021-Present',
      description: 'Currently pursuing a BSc in Computer Science with a focus on artificial intelligence and software development.',
      highlights: [
        'Artificial Intelligence',
        'Object Oriented Programming',
        'Data Structure and Algorithms',
        'Human Computer Interaction',
        'Probability and Statistics',
        'Database Management',
        'Internet Programming'
      ]
    }
  ];

  return (
    <div className="education">
      <h2 className="section-title">Education</h2>
      <div className="education-timeline">
        {education.map((edu, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-content">
              <h3>{edu.institution}</h3>
              <div className="year">{edu.year}</div>
              <p>{edu.description}</p>
              <ul className="highlights">
                {edu.highlights.map((highlight, hIndex) => (
                  <li key={hIndex}>{highlight}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
